export var SENTRY_DSNS = {
    DASHBOARD_DSN: 'https://f3cf1f9256ce4927b49e504cf4e86d95@sentry.wixpress.com/156',
    ARENA_DSN: 'https://7d8825a8a89a419daeee5f7e7de32b45@sentry.wixpress.com/157',
    FEEDBACK_DSN: 'https://0d1b4df20f154397bb140c0815158892@sentry.wixpress.com/1009',
};
// TODO: decide what should be deleted between the two options
export var DASHBOARD_DSN = 'https://f3cf1f9256ce4927b49e504cf4e86d95@sentry.wixpress.com/156';
export var ARENA_DSN = 'https://7d8825a8a89a419daeee5f7e7de32b45@sentry.wixpress.com/157';
export var FEEDBACK_DSN = 'https://0d1b4df20f154397bb140c0815158892@sentry.wixpress.com/1009';
//# sourceMappingURL=dsn.js.map